import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { CardInput } from '@trackback/widgets';
import { AsyncPipe } from '@angular/common';
import { ParsePipe } from '@app/pipes/parse.pipe';
import { MatCard } from '@angular/material/card';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';

@Component({
  selector: 'tb-card',
  imports: [DynamicWidgetDirective, AsyncPipe, ParsePipe, MatCard],
  template: `
    <mat-card
      [class]="input().styleClasses | parse: context() | async"
      [appearance]="input().appearance ?? 'raised'"
    >
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-card>
  `,
  styles: `
    tb-card {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class CardComponent extends WidgetInputBaseComponent<CardInput> {}
